import { SVGProps, Ref, forwardRef } from 'react';

export const KeyFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M5.273 4.628c.303 0 .457.079.51.123a.25.25 0 0 1 .07.102c.027.063.065.192.065.42s-.038.357-.064.42a.25.25 0 0 1-.07.103c-.054.044-.208.122-.51.122-.304 0-.458-.078-.511-.122a.25.25 0 0 1-.07-.103 1.1 1.1 0 0 1-.065-.42c0-.228.038-.357.064-.42a.25.25 0 0 1 .07-.102c.054-.044.209-.123.511-.123"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.954.5c2.727 0 5.455 1.364 5.455 5.454q-.002.799-.134 1.463l.816.816v1.13h1.13l.233.234v1.13h1.13l.916.916v2.834L11.643 15.5 7.41 11.268a7.4 7.4 0 0 1-1.457.141C3.227 11.41.5 10.045.5 5.954.5 1.864 3.227.5 5.954.5m-.68 2.728c-1.023 0-2.046.511-2.046 2.045S4.25 7.318 5.273 7.318s2.045-.511 2.045-2.045-1.022-2.045-2.045-2.045"
                fill="currentColor"
            />
        </g>
    </svg>
));
KeyFilledSize16Glyph.displayName = 'KeyFilledSize16Glyph';
